<template>
  <div  :class="headerWhite?'style-white':''" v-show="isShowContent">
    <div class="header"  :class="isLogoLangWhite?'header-white':''" :style="pageName==='contact'?'':' background: #fff;'">
      <router-link to="/search" class="search"></router-link>
      <div :class="'logo-'+getLanguageName" @click="$goToHome()">
      </div>
      <a href="javascript:;"  :class="getLanguageName=='cn'?'lang-en':'lang-cn'"  @click="changeLanguage()"></a>
    </div>
    <slot></slot>
    <div class="footer">
      <router-link to="/contact" class="contact" v-if="pageName==''"></router-link>
       <router-link to="/" class="contact" v-else-if="pageName=='contact'"></router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: "Container",
  data() {
    return {
      headerWhite:false,//true表示白色 false 表示黑色
      scrollHeight:0,
      colorID:1,
      imgCount:0,
      loadImgCount:0,
      isLogoLangWhite:false//true表示白色  false 表示黑色 
    }
  },
  props: {
   
    logoHeightSet:{
        type: Array,
        default: () => []
    }, 

    isHeightSet:{
      type: Boolean,
      default: false
    },

    isHeaderWhite:{
      type: Boolean,
      default: false   
    },


    isShowDetail:{
      type: Boolean,
      default: false    
    },
    isShowContent:{
      type: Boolean,
      default: false    

    },
    pageName:{


      type: String,
      default: ''    
    }


  },
  components: {},
  methods: {

    changeData(){

   
      this.setColor(this.scrollHeight);
    },
    
     scroll() {

      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop

      this.setColor(scrollTop)

      this.$emit('scroll', scrollTop)

      this.scrollHeight = scrollTop

     
    }, 
     setColor(scrollTop){





      if(this.logoHeightSet && this.logoHeightSet.length>0){
        let info = this.logoHeightSet.find(item => item.minHeight <= scrollTop && item.maxHeight>scrollTop);

        if(info){

    
            this.colorID = info.ColorID

            if(info.ColorID==1){
              this.headerWhite = false //默认黑色
          
            }else{
              this.headerWhite = true //默认白色
           
            }


            this.getColorState()

        }       

      }

    },   
    
    
    changeLanguage(){
      this.$store.dispatch('language/changeLanguage')
      this.$emit('click', this.getLanguageName)
    },

    btnMask() {
      /*const $ = jQuery
      $('.btn-mask').hover(function () {
        $(this).parent().css({zIndex: 100})
        $('.mask').fadeIn()
      }, function () {
        //$(this).parent().css({zIndex: ''})
        $('.mask').fadeOut()
      })*/
    },
    getColorState(){

    
      if(this.isShowDetail){
        this.isLogoLangWhite = false
      }else{
    
             if(this.colorID==1){
              this.isLogoLangWhite = false //黑色

            }else{
               this.isLogoLangWhite = true //默认黑色

            }       
      }
    
    }
  },
  computed: {
    getLanguageName(){

      return this.$store.state.language.name

    },

  },
  mounted() {


    this.$nextTick(() => {
      window.addEventListener("scroll", this.scroll, false)
      this.btnMask()
    })


    if(this.isHeaderWhite){

        this.headerWhite = true
        this.isLogoLangWhite = true
     
    }        


  },
  watch:{
     logoHeightSet:{
      immediate: true,
      handler() {
        this.scroll()
      }
    }, 
    getLanguageName(){
      this.changeData()
    },
    isShowDetail:{
    immediate: true,
      handler() {
    
       this.getColorState()
      }
      
    },
  }  
}
</script>
